import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { requestVerificationCode, verifyPhoneCode } from '../services/authService';
import { AppContext } from '../context/AppContext';

class LoginPage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      phoneNumber: '',
      verificationCode: '',
      loading: false,
      errorMessage: '',
      successMessage: '',
      redirectToHome: false,
    };
  }

  handlePhoneChange = (event) => {
    this.setState({
      phoneNumber: event.target.value,
      errorMessage: '',
      successMessage: '',
    });
  };

  handleCodeChange = (event) => {
    this.setState({
      verificationCode: event.target.value,
      errorMessage: '',
      successMessage: '',
    });
  };

  handleRequestCode = (event) => {
    event.preventDefault();

    const { phoneNumber } = this.state;

    if (!phoneNumber.trim()) {
      this.setState({ errorMessage: 'יש להזין מספר טלפון' });
      return;
    }

    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    requestVerificationCode(phoneNumber)
      .then((response) => {
        this.setState({
          loading: false,
          step: 2,
          successMessage: response.message || 'קוד אימות נשלח לוואטסאפ',
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בשליחת קוד האימות',
        });
      });
  };

  handleVerifyCode = (event) => {
    event.preventDefault();

    const { dispatch } = this.context;
    const { phoneNumber, verificationCode } = this.state;

    if (!verificationCode.trim()) {
      this.setState({ errorMessage: 'יש להזין קוד אימות' });
      return;
    }

    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    verifyPhoneCode(phoneNumber, verificationCode)
      .then((response) => {
        if (response.session_id) {
          localStorage.setItem('session_id', response.session_id);
        }

        dispatch({
          type: 'SET_AUTH',
          payload: true,
        });

        this.setState({
          loading: false,
          successMessage: response.message || 'התחברת בהצלחה',
          redirectToHome: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'קוד שגוי או שפג תוקפו',
        });
      });
  };

  renderPhoneStep() {
    const { phoneNumber, loading } = this.state;

    return (
      <form className="login-form" onSubmit={this.handleRequestCode}>
        <label className="input-label">מספר טלפון</label>
        <input
          type="tel"
          className="login-input"
          placeholder="הזן מספר טלפון"
          value={phoneNumber}
          onChange={this.handlePhoneChange}
          dir="ltr"
        />

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'שולח...' : 'שלח קוד אימות'}
        </button>
      </form>
    );
  }

  renderCodeStep() {
    const { verificationCode, loading, phoneNumber } = this.state;

    return (
      <form className="login-form" onSubmit={this.handleVerifyCode}>
        <div className="phone-display">
          הקוד נשלח למספר: <span dir="ltr">{phoneNumber}</span>
        </div>

        <label className="input-label">קוד אימות</label>
        <input
          type="text"
          className="login-input"
          placeholder="הזן קוד אימות"
          value={verificationCode}
          onChange={this.handleCodeChange}
          dir="ltr"
        />

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'מאמת...' : 'אמת והתחבר'}
        </button>

        <button
          type="button"
          className="back-button"
          onClick={() =>
            this.setState({
              step: 1,
              verificationCode: '',
              errorMessage: '',
              successMessage: '',
            })
          }
        >
          חזור
        </button>
      </form>
    );
  }

  render() {
    const { step, errorMessage, successMessage, redirectToHome } = this.state;

    if (redirectToHome) {
      return <Navigate to="/" />;
    }

    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-header">
            <h1>התחברות</h1>
            <p>התחבר באמצעות מספר טלפון וקוד אימות מוואטסאפ</p>
          </div>

          {errorMessage && <div className="message-box error-box">{errorMessage}</div>}
          {successMessage && <div className="message-box success-box">{successMessage}</div>}

          {step === 1 ? this.renderPhoneStep() : this.renderCodeStep()}
        </div>
      </div>
    );
  }
}

export default LoginPage;